const classPrefix = 'banner-why-us'
const dataPrefix = 'data-banner-why-us'
const $container = document.querySelector(`[${dataPrefix}]`)


export function bannerWhyUs() {


}
